export const actionSetTourismPartnerSelectedType = (typePartner) => ({
  type: "SET_TOURISM_PARTNER_SELECTED_TYPE",
  typePartner,
});

export const actionSetTourismPartnerSelectedPartner = (partner) => ({
  type: "SET_TOURISM_PARTNER_SELECTED_PARTNER",
  partner,
});
